import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { assertBadHttpStatus } from './assert';
import { fetchGetOffersByLayoutMobile } from '../shared/repositories/newbuilding-card/v1/get-offers-by-layout-mobile';
import { assertNotFoundResponse } from './assert/assertNotFoundResponse';
export function fetchLayoutsOffers(_x) {
  return _fetchLayoutsOffers.apply(this, arguments);
}
function _fetchLayoutsOffers() {
  _fetchLayoutsOffers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var params, httpApi, logger, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _ref.params, httpApi = _ref.httpApi, logger = _ref.logger;
          _context.prev = 1;
          _context.next = 4;
          return fetchGetOffersByLayoutMobile({
            httpApi: httpApi,
            parameters: params,
            config: {
              requestConfig: {
                headers: [['Content-Type', 'application/json']]
              }
            }
          });
        case 4:
          response = _context.sent;
          assertBadHttpStatus(response);
          assertNotFoundResponse(response);
          return _context.abrupt("return", response.response.layout || null);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            domain: 'src/services/fetchLayoutsOffers'
          });
          return _context.abrupt("return", null);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _fetchLayoutsOffers.apply(this, arguments);
}